import { create } from 'zustand'

interface CreditsModalState {
  isOpen: boolean
  openModal: () => void
  closeModal: () => void
}

export const useCreditsModalStore = create<CreditsModalState>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
}))
